export default {
	init() {
		// JavaScript to be fired on the crew page
		// Open magPopup based on URL hash
		if (location.hash) {
			let hash = location.hash.replace("#", "");

			// Find matching link and trigger magnificPopup
			let target = $(".related-posts").find(`[data-name='${hash}']`);
			target.trigger("click");
		}
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/the-crew.js